import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const appDownloadButtonClickedEvent = EVENT_PAYLOAD;
export const appDownloadButtonSelectedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map